import { BackendResponse } from "../BackendResponse";
import { NextApiParams, withNextApi } from "../nextApiHelpers";
import { CvPortalTranslationOverride } from "./CvPortalTranslationOverride";

export interface GetCvPortalTranslationOverridesResponse
  extends BackendResponse {
  items: CvPortalTranslationOverride[];
  locale: string;
}

export interface GetCvPortalTranslationOverridesParameters
  extends NextApiParams {
  locale?: string;
}

export const getCvPortalTranslationOverrides = withNextApi<
  GetCvPortalTranslationOverridesResponse,
  GetCvPortalTranslationOverridesParameters
>("/CvpSettings/GetCvPortalTranslationOverrides", { method: "GET" });
